// vue-x模块化写法
export default {
  state: {
    resList: [],
    barChartList: [[]],
    annualProValue: 0,
    bigIndustryNo: 0
  },
  mutations: {
    commitResData (state, data) {
      state.resList = data.resList
      state.annualProValue = data.annualProValue
      state.barChartList = data.barChartList
      state.bigIndustryNo = data.bigIndustryNo
    }
  }
}
